import { defineMessages } from 'react-intl';

export const scope = 'app.containers.StatusLabels';

export default defineMessages({
  noLink: {
    id: `${scope}.noLink`,
    defaultMessage: '{label} does not have a link',
  },
  noVideos: {
    id: `${scope}.noVideos`,
    defaultMessage: 'No videos for {label}',
  },
  defaultError: {
    id: `${scope}.defaultError`,
    defaultMessage: 'There was an error with {label}',
  },
  cancelAndReschedule: {
    id: `${scope}.cancelAndReschedule`,
    defaultMessage:
      'Applicant has been notified of session cancellation and has been requested to reschedule',
  },
  requestReschedule: {
    id: `${scope}.requestReschedule`,
    defaultMessage: 'Applicant has been requested to reschedule',
  },
  rescheduledTooltip: {
    id: `${scope}.rescheduledTooltip`,
    defaultMessage: 'Rescheduled {count} times',
  },
  collapseStatusLabel: {
    id: `${scope}.collapseStatusLabel`,
    defaultMessage: 'Collapse',
  },
  expandStatusLabel: {
    id: `${scope}.expandStatusLabel`,
    defaultMessage: 'Show all {count}',
  },
  stillValidFor: {
    id: `${scope}.stillValidFor`,
    defaultMessage: 'Still valid for: {count, plural, one {# day} other {# days}}',
    description:
      'How many days a passing background check can still be reused for, on the applicant list status pill',
  },
  validityWindowClosed: {
    id: `${scope}.validityWindowClosed`,
    defaultMessage: 'Validity window closed',
    description:
      'Tells a recruiter the background check on file can no longer be reused, on the applicant list status pill. The day it stopped being valid reads in the Partner Details popup',
  },
});
